module.exports = __webpack_public_path__ + "static/media/softimize.7eb8bd69.png";